import * as React from 'react';
import { RenderHtml } from '../../helpers/render-html';
import { isNameAvailable } from '../../helpers/api.client';
import { Logger, withLogger } from '../../helpers/bi/bi-logger';
import { BIEvent } from '../../helpers/bi/event-type';
import { ANSWERS_BASE_DOMAIN, signupUrl, checkIfMobile } from '../../helpers/utils';
import { MarketingInput } from '@wix/answers-common-components';
import { MobileLock } from '../mobile-lock/comp';
import { TinyLoader } from '@wix/answers-ui-libby';
import { withTranslator } from '../../helpers/shared';
import { TranslateFn } from '@wix/answers-lib';

export type LoginTenantProps = withLogger & withTranslator;

export class LoginTenant extends React.PureComponent<LoginTenantProps> {
	logger: Logger = this.props.logger;
	compTranslate: TranslateFn = (key, params) => this.props.t(`marketing-site.signup-form.login.${key}`, params);

	state = {
		subdomain: '',
		subdomainError: '',
		submitting: false
	};

	isNotEmpty = () => {
		return !!this.state.subdomain;
	}

	login = (e: any) => {
		e.preventDefault();
		e.stopPropagation();

		if (this.state.submitting) {
			return;
		}

		const sub = this.state.subdomain;
		this.logger.logEvent(BIEvent.LOGIN_NEXT_CLICK, {subdomain: sub});

		if (!sub) {
			this.setState({subdomainError: this.compTranslate('errors.enter-subdomain')});
			this.logger.logEvent(BIEvent.LOGIN_REDIRECT_FAIL, {subdomain: sub, error: 'Sudomain is empty'});
		} else {
			this.setState({submitting: true});
			isNameAvailable(sub)
				.then((res) => {
					if (res) {
						const error = 'No account was found for the domain';
						this.logger.logEvent(BIEvent.LOGIN_REDIRECT_FAIL, {subdomain: sub, error});
						this.setState({subdomainError: this.compTranslate('errors.no-account', {subdomain: sub, error}), submitting: false});
					} else {
						this.logger.logEvent(BIEvent.LOGIN_REDIRECT_SUCCESS, {subdomain: sub});
						location.replace(`https://${sub}${ANSWERS_BASE_DOMAIN}/account/agents/signin`);
					}
				});
		}

		return false;
	}

	onChange = (val: string) => {
		const processedValue = val.replace(/^\s+/, '').replace(/\s+/g, '-');
		this.setState({subdomain: processedValue, subdomainError: ''});
	}

	validateSubdomainName = () => {
		if (this.state.subdomain.trim()) {
			isNameAvailable(this.state.subdomain)
			.then((res) => {
				if (res) {
					const errorReason = 'No account was found for the domain';
					this.setState({subdomainError: this.compTranslate('errors.no-account', {subdomain: this.state.subdomain, errorReason})});
				}
			});
		}
	}

	render () {
		const {state, props, compTranslate} = this;
		const isPrimaryOrHollowBtn = this.isNotEmpty() ? 'primary-btn' : 'hollow-btn';

		const loginForm = (
			<div className='new-login-form-container'>
				<form noValidate={true} onSubmit={this.login}>
					<MarketingInput
						className='subdomain'
						maxLength={30}
						fixedPlaceholder={ANSWERS_BASE_DOMAIN}
						error={this.state.subdomainError}
						errorTooltipPosition='left'
						value={this.state.subdomain}
						type='text'
						label={compTranslate('field.subdomain')}
						onChange={this.onChange}
						onBlur={this.validateSubdomainName}
						startFocused={true}
					/>
				</form>
				<div className='forgot-domain-cta-wrapper'>
					<a className='forgot-domain-cta' href='/forgot'>{compTranslate('forgot-domain-cta')}</a>
				</div>
			</div>
		);

		const isMobile = checkIfMobile();

		return !isMobile ? (
			<div className={`new-login-container ${state.submitting ? 'submitting' : ''}`}>
				<header>
					<h1><RenderHtml html={compTranslate('title')} /></h1>
					<h2 className='helper'>{compTranslate('no-account')}<a href={signupUrl}>{compTranslate('no-account-cta')}</a></h2>
				</header>
				<main>{loginForm}</main>
				<footer>
					<button className={`submit-login-cta ${isPrimaryOrHollowBtn}`} type='submit' onClick={this.login}>
						{state.submitting ? <TinyLoader/> : compTranslate('next-button')}
					</button>
				</footer>
			</div>
		) : <MobileLock isLogin={true} t={props.t}/>;
	}
}
